"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLoadingMaskSpinner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoadingMaskMixin = require("../../mixins/components/LoadingMaskMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledLoadingMaskSpinner = /*#__PURE__*/_styledComponents.default.div.withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['loading'])
}).withConfig({
  displayName: "StyledLoadingMaskSpinner",
  componentId: "c11n-8-107-0__sc-7w2q44-0"
})(["", ""], _LoadingMaskMixin.LoadingMaskSpinnerMixin);
exports.StyledLoadingMaskSpinner = StyledLoadingMaskSpinner;